import React, { useState } from 'react';

import { nanoid } from '@reduxjs/toolkit';
import { useLocation } from 'react-router';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { userActions, useStore } from '@modules';
import { ProtectNextEnum } from '@modules/types';

import Verification from '@containers/Verification';

import EmailTooltip from './EmailTooltip';

import style from './Verification.scss';

const cn = bemCssModules(style, 'Verification');
export type ChangePasswordVerifyEmailType = {
  password?: string;
  onSuccess(): void;
};

const { verifyOTP } = ProtectNextEnum;

export const ChangePasswordVerifyEmail: CustomFC<ChangePasswordVerifyEmailType> = props => {
  const { password, onSuccess } = props;
  const [resendButtonId] = useState(nanoid());
  const navigate = useNavigate();
  const { state } = useLocation();

  const [{ user }, dispatch] = useStore();
  const isLoading = !!user.loaders.changePasswordVerifyEmail;

  const handleSubmit = (code: string, key: string) => {
    dispatch(userActions.changePasswordVerifyEmail({ key, code }))
      .unwrap()
      .then(response => {
        if (!password) return;
        const data = {
          key: response.data.key,
          new_password: password,
        };

        if (response.data.next === verifyOTP) {
          navigate<'verifications'>(CONST.nav.verification, {
            state: {
              ...state,
              token: response.data.token,
              flow: 'changePasswordVerifyOTP',
            },
          });
        } else {
          dispatch(userActions.changePasswordSetPassword(data)).unwrap().then(onSuccess);
        }
      });
  };

  return (
    <Verification
      customInputClass={cn('custom-input')}
      onVerify={handleSubmit}
      isLoading={isLoading}
      tooltip={<EmailTooltip id={resendButtonId} />}
      type="email"
      id={resendButtonId}
    />
  );
};

export default ChangePasswordVerifyEmail;
